function getHead(vm) {
  const { head } = vm.$options
  if (head) {
    return typeof head === 'function'
      ? head.call(vm)
      : head
  }
}

const serverHeadMixin = {
  created () {
    const head = getHead(this)
    if (head) {
      if (head.title) {
        this.$ssrContext.title = `${head.title}`
      }

      if (head.mataInfo) {
        this.$ssrContext.metaInfo = head.mataInfo;
      }
    }
  }
}

const clientHeadMixin = {
  mounted () {
    const head = getHead(this)
    if (head) {
      if (head.title) {
        document.title = `HONEYEE.COM | ${head.title}`
      }
      // if (head.keyword) {
      //   document.getElementsByName("keywords")[0].content = head.keyword;
      // }
      //
      // if (head.description) {
      //   document.getElementsByName("description")[0].content = head.description;
      // }
    }
  }
}

export default process.env.VUE_ENV === 'server'
  ? serverHeadMixin
  : clientHeadMixin



// WEBPACK FOOTER //
// src/util/head.js